/* Audit fixes, Oct 2026. Product pages: make the Avis Bundles widget start on 1 unit instead of 2.
   Stops as soon as the shopper picks an option themselves. Delete this file and its line in snippets/meta-tags.liquid to undo. */
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  var touched = false;
  document.addEventListener('click', function (e) {
    if (e.isTrusted && e.target.closest && e.target.closest('.avisbls-radio, label')) touched = true;
  }, true);
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    if (touched || tries > 40) { clearInterval(timer); return; }
    var first = document.getElementById('avisbls-offer-0');
    if (first && !first.checked) first.click();
  }, 250);
})();
